import { render, staticRenderFns } from "./permission-combox.vue?vue&type=template&id=247e4dbe&scoped=true&"
import script from "./permission-combox.vue?vue&type=script&lang=js&"
export * from "./permission-combox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247e4dbe",
  null
  
)

export default component.exports